module.exports = "fragment Canton on CantonType{__typename id name prologueCode departement{__typename id name:nomDept region{__typename id name}}}"